import { message, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import {
  deleteRecipesCategory,
  refreshTableRecipesCategories,
  setRecipesCategoryForUpdate,
  setIsRecipesCategoryForUpdate,
  RecipesCategoriesChangeModalState,
} from "../../../redux";
import { DataRecipesCategory } from "../../../redux/@types/recipesCategories";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { useRecipesCategories } from "./useRecipesCategories";

const { confirm } = Modal;

export const useTableRecipesCategories = () => {
  const dispatch = useAppDispatch();
  const { tableProps } = useRecipesCategories();

  const changeRecipesCategoryForUpdate = (val: any) => {
    dispatch(setIsRecipesCategoryForUpdate(true));
    dispatch(setRecipesCategoryForUpdate(val));
    dispatch(RecipesCategoriesChangeModalState(true));
  };

  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: `¿Estás seguro de borrar la categoría con el id: ${valId}?`,
      icon: <ExclamationCircleOutlined />,
      content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}", si deseas continuar dale click a "Borrar categoría" en caso tal solo oprime en "Cancelar".`,
      okText: "Borrar categoría",
      okType: "danger",
      cancelText: "Cancelar",
      async onOk() {
        await deleteRecipesCategory(valId)
          .then((res) => {
            dispatch(refreshTableRecipesCategories(true));
            if (res && typeof res === "object" && res.name) {
              message.success(
                `Se ha borrado con éxito la categoría con id:${valId}`
              );
            } else if (res) {
              message.error(`${res}`);
            }
            tableProps?.refresh();
          })
          .catch((err) => {
            message.error(err.message);
          });
      },
      onCancel() {},
    });
  };

  return {
    changeRecipesCategoryForUpdate,
    showDeleteConfirm,
  };
};
